import {
  Drzava,
  PrimarniIdentifikatorDrzavaIzdavaljetelj,
  PrimarniIdentifikatorVrijednost,
  RegistarskiBroj,
} from "../../../index";
import { Card, CardContent, CardHeader, Grid, Input } from "@mui/material";
import { VRSTA_OPERATERA } from "../../../../enums";
import { useFormContext } from "react-hook-form";

const Index = () => {
  const { register, getValues } = useFormContext();
  const vrstaOperatera = getValues("operaterPlatforme.vrstaOperatera.id");
  const naziv = getValues("poslovniNazivPlatforme");

  return (
    <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
      <CardHeader
        title={`Poslovni naziv platforme (Platform business name): ${naziv}`}
        titleTypographyProps={{ variant: "h6" }}
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <RegistarskiBroj />
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={6}>
              <Drzava
                nazivPolja={
                  "operaterPlatforme.primarniIdentifikator.drzavaRezidentnosti.oznaka"
                }
                nazivPoljaEu={
                  "operaterPlatforme.primarniIdentifikator.drzavaRezidentnosti.euSifra"
                }
                label={"*Država rezidentnosti (Country of residency)"}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={6}>
              <PrimarniIdentifikatorVrijednost disabled={true} />
            </Grid>
            {vrstaOperatera !== VRSTA_OPERATERA.IZ_RH && (
              <Grid item xs={6} sx={{ mt: 2 }}>
                <PrimarniIdentifikatorDrzavaIzdavaljetelj
                  nazivPolja={
                    "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.oznaka"
                  }
                  nazivPoljaEu={
                    "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.euSifra"
                  }
                  disabled={true}
                />
              </Grid>
            )}
            {vrstaOperatera === VRSTA_OPERATERA.IZ_RH && (
              <>
                <Input
                  type={"hidden"}
                  value={"HRV"}
                  {...register(
                    "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.oznaka"
                  )}
                />
                <Input
                  type={"hidden"}
                  value={"HR"}
                  {...register(
                    "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.euSifra"
                  )}
                />
              </>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Index;
